/* Free keychain — one in every order, added and removed automatically.
 *
 * RULES (Diego 2026-08-22):
 *   cart has any other product  -> exactly ONE keychain is present
 *   cart has nothing else       -> the keychain is removed
 *
 * WHY A fetch WRAPPER AND NOT JUST EVENTS. Items reach the cart from at least five places
 * on this site — the product form, quick-add, the sticky ATC bar, the cart-drawer upsell
 * and the fit builder — and they do not all dispatch the same events. Wrapping fetch means
 * anything that talks to /cart/* is caught, including code added later that knows nothing
 * about this file.
 *
 * WHY IT CANNOT LOOP. reconcile() only issues a request when the cart is in the wrong
 * state, so the mutation it makes is exactly the one that stops it firing again: add ->
 * cart now correct -> next pass does nothing. FAIL_LIMIT stops it retrying for ever
 * against an error (a hard 422 would otherwise fire a request on every cart change for
 * the rest of the session).
 *
 * 🚨 WHY THE LOCK SPANS THE READ, NOT JUST THE WRITE. First version set `busy` inside the
 * POST only. One add fires several triggers at once (the fetch wrapper AND cart:updated
 * AND ajaxProduct:added), so two passes both got as far as reading /cart.js, both saw "no
 * keychain", and both added one — TWO KEYCHAINS IN THE BAG. The lock is now taken before
 * the read and released after the write, so a pass can never act on a cart another pass
 * has already decided to change. Triggers are also debounced into one.
 *
 * The PRICE is not set here. A scheduled automatic discount ("BTS FREE KEYCHAIN", 100% off,
 * min $15 subtotal) makes it free from 29 Aug. Until then this adds it at $12, which is why
 * the script is on the DRAFT theme only. Deliberate: a $0 variant would let anyone order
 * unlimited free keychains from the product page, the minimum-subtotal rule cannot.
 */
(function () {
  var KEYCHAIN_VARIANT = 43108997431357;
  var FAIL_LIMIT = 3;
  var busy = false, fails = 0, timer = null;

  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { if (!r.ok) { fails++; } return r.json().catch(function () { return {}; }); })
      .catch(function () { fails++; })
      .then(function () {
        /* redraw the drawer/cart with the line we just changed */
        document.dispatchEvent(new CustomEvent('cart:build'));
      });
  }

  function reconcile() {
    if (busy || fails >= FAIL_LIMIT) return;
    busy = true;                                   /* held across read AND write */
    return fetch('/cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var lines = [], others = 0;
        (cart.items || []).forEach(function (i) {
          if (i.variant_id === KEYCHAIN_VARIANT) { lines.push(i); }
          else { others += i.quantity; }
        });
        var kc = lines[0] || null;
        /* Belt and braces: if a race ever does slip two SEPARATE lines through, drop the
           extras. Shopify normally merges same-variant lines, so this is the rare case. */
        if (lines.length > 1) { return post('/cart/change.js', { id: lines[1].key, quantity: 0 }); }
        if (others > 0 && !kc) { return post('/cart/add.js', { items: [{ id: KEYCHAIN_VARIANT, quantity: 1 }] }); }
        if (others === 0 && kc) { return post('/cart/change.js', { id: kc.key, quantity: 0 }); }
        /* exactly one, always */
        if (others > 0 && kc && kc.quantity !== 1) { return post('/cart/change.js', { id: kc.key, quantity: 1 }); }
      })
      .catch(function () {})
      .then(function () { busy = false; });
  }

  /* Several triggers fire for a single add; collapse them into one pass. */
  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(reconcile, 150);
  }

  /* Catch every route into the cart, whoever wrote it. */
  var _fetch = window.fetch;
  window.fetch = function (input, init) {
    var url = (typeof input === 'string') ? input : (input && input.url) || '';
    var out = _fetch.apply(this, arguments);
    if (/\/cart\/(add|change|update)(\.js)?/.test(url) && !busy) {
      out.then(function () { schedule(); }).catch(function () {});
    }
    return out;
  };

  document.addEventListener('cart:updated', schedule);
  document.addEventListener('ajaxProduct:added', schedule);

  if (document.readyState !== 'loading') { schedule(); }
  else { document.addEventListener('DOMContentLoaded', schedule); }
})();
